import React from "react";
import { Box, Chip } from "@mui/material";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import axios from "axios";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import VerifiedIcon from "@mui/icons-material/Verified";
import Header from "../../components/Header";
import SetupGuide from "../../components/SetupGuide";
import swal from "sweetalert";
import AddIcon from "@mui/icons-material/Add";
import Row from "./CustomTable";
import { useNavigate } from "react-router-dom";

function GoogleDrive() {
  const [isDone, setIsDone] = useState(false);
  const [tableValues, setTableValues] = useState([]);
  const [reconfigure, setReconfigure] = useState(true);

  async function checkUserIsAuth() {
    await axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/user-details?appId=Google drive`,
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        if (response.data.isDone === true) {
          setIsDone(true);
          setTableValues(response.data.message);
          if (!response.data.refreshTokenValidity) {
            setReconfigure(false);
          }
        }
      });
  }

  async function authorizeAccess() {
    await axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/google-drive-url?app_id=Google drive`,
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        const url = response.data;
        window.location.replace(url);
      });
  }

  async function deleteTableRow(file_id, file_name, index) {
    swal(
      "Are you sure!",
      `Do you want to delete your token gating configuration for file: ${file_name}`,
      "warning",
      {
        buttons: ["Cancel", "OK"],
      }
    ).then(async (value) => {
      if (value) {
        await axios
          .delete(
            `${process.env.REACT_APP_BASE_URL}/google-drive-file?appId=Google drive&fileId=${file_id}`,
            {
              headers: {
                "content-type": "application/json",
                token: localStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            if (response.data.status === true) {
              let newTableValues = [...tableValues];
              newTableValues.splice(index, 1);
              setTableValues(newTableValues);
              swal(
                "Deleted!",
                `Your token gating configuration for file: ${file_name} is successfully deleted.`,
                "success",
                {
                  button: "OK",
                }
              );
            } else {
              swal("Something went wrong!", ``, "error", {
                button: "OK",
              });
            }
          })
          .catch((err) => {
            swal({
              text: err.response.data.errorMessage,
              icon: "error",
              // type: "error"
            });
          });
      }
    });
  }

  const navigate = useNavigate();

  async function editTableRow(row) {
    navigate("/token-gating/google-drive/configuration", {
      state: row,
    });
  }

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  async function addConfiguration() {
    navigate("/token-gating/google-drive/configuration");
  }

  useEffect(() => {
    (async () => {
      await checkUserIsAuth();
    })();
  }, []);

  return (
    <Box m="20px">
      <div style={{ marginBottom: "40px" }}>
        <Header title="Give Access" />
        
      </div>

      {reconfigure ? (
        <div>
          <div
            style={{ cursor: isDone && "not-allowed", width: "fit-content", display : 'flex', width: "100%", justifyContent: 'space-between', height: '3rem' }}
          >
            <Button
              className="custom-color-button"
              disabled={isDone}
              variant="contained"
              onClick={authorizeAccess}
              color="info"
              sx={{
                fontSize: "15px",
              }}
            >
              Authorize Access
            </Button>
            <SetupGuide url={process.env.REACT_APP_GOOGLE_DRIVE_SETUP_GUIDE} />
          </div>

          <Chip
            pl="0"
            style={{
              marginTop: ".6rem",
              paddingLeft: "0",
              border: "none",
              fontSize: "1rem",
              fontFamily: "Poppins",
            }}
            variant="outlined"
            size="small"
            icon={
              isDone ? (
                <VerifiedIcon className="verifiedIcon" fontSize="medium" />
              ) : null
            }
            label={
              isDone
                ? "You have already given Access to your Google Drive"
                : "Click Authorize Access Button to give access of your google drive"
            }
          />
        </div>
      ) : (
        <div>
          <Button
            className="custom-color-button"
            variant="contained"
            onClick={authorizeAccess}
            color="info"
            sx={{
              fontSize: "15px",
            }}
          >
            Reconfigure Acesss
          </Button>
          <br />
          <Chip
            pl="0"
            style={{
              marginTop: ".6rem",
              paddingLeft: "0",
              border: "none",
              fontSize: "1rem",
              fontFamily: "Poppins",
            }}
            variant="outlined"
            size="small"
            icon={null}
            label={"Please Reconfigure access to your google drive"}
          />
        </div>
      )}
      <br />
      <br />
      <Box
        variant="gradient"
        textAlign="left"
        sx={{
          marginTop: "30px",
          display: !isDone ? "none" : "block",
        }}
      >
        <div>
          <div style={{ display: "inline-block" }}>
            <Header title="Configure" />
          </div>
          <Button
            className="custom-color-button"
            color="info"
            sx={{
              backgroundColor: "#6870fa",
              float: "right",
              marginTop: "4px",
              fontSize: "15px",
            }}
            variant="contained"
            startIcon={<AddIcon />}
            onClick={addConfiguration}
          >
            Add Configuration
          </Button>
          <Box minHeight="40vh">
            <Paper sx={{ width: "100%", boxShadow: 4 }}>
              <TableContainer>
                <Table aria-label="collapsible table">
                  <TableHead>
                    <TableRow>
                      <TableCell className="tableHead" />
                      <TableCell
                        className="tableHead"
                        sx={{ textAlign: "left !important" }}
                      >
                        File name
                      </TableCell>
                      <TableCell className="tableHead" align="center">
                        Sharable link
                      </TableCell>
                      <TableCell className="tableHead" align="center">
                        Edit
                      </TableCell>
                      <TableCell className="tableHead" align="center">
                        Delete
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableValues
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <Row
                          deleteTableRow={deleteTableRow}
                          editTableRow={editTableRow}
                          key={row.fileId}
                          index={index}
                          row={row}
                        />
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                component="div"
                count={tableValues.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Box>
        </div>
      </Box>
    </Box>
  );
}

export default GoogleDrive;
